module.exports = __webpack_public_path__ + "static/media/BTS.a064df47.png";